<template>
  <figure :id="id ? `c${id}` : undefined" :class="$style.container">
    <slot />
    <figcaption v-show="caption !== ''">{{ caption }}</figcaption>
  </figure>
</template>

<script>
export default {
  name: 'BaseFigure',
  props: {
    id: {
      type: String,
      default: undefined,
    },
    caption: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" module>
.container {
  width: 100%;
}
</style>
